import { useRef, type CSSProperties, type ReactNode } from 'react';
import { useElementWidth } from '@/hooks/useElementWidth';
import { cn } from '@/lib/utils';
import { TABLE_SCROLLBAR_CLASS } from '@/styles/scrollbar';
import { TABLE_VISIBLE_WIDTH_VAR } from './dataTable.constants';

const DESKTOP_MIN_TABLE_HEIGHT_CLASS = 'lg:min-h-72';

type ScrollAreaStyle = CSSProperties & Record<typeof TABLE_VISIBLE_WIDTH_VAR, string>;

interface TableScrollFrameProps {
  className?: string | undefined;
  children: ReactNode;
}

export function TableScrollFrame({ className, children }: TableScrollFrameProps) {
  const scrollAreaRef = useRef<HTMLDivElement>(null);
  const visibleWidthPx = useElementWidth(scrollAreaRef);
  const scrollAreaStyle: ScrollAreaStyle | undefined =
    visibleWidthPx === undefined ? undefined : { [TABLE_VISIBLE_WIDTH_VAR]: `${visibleWidthPx}px` };

  return (
    <div
      className={cn(
        'flex flex-col w-full rounded-2xl bg-card ring-1 ring-primary/12',
        DESKTOP_MIN_TABLE_HEIGHT_CLASS,
        className,
      )}
      style={{ overflow: 'clip' }}
    >
      <div
        ref={scrollAreaRef}
        className={cn('min-h-0 flex-1 overflow-auto', TABLE_SCROLLBAR_CLASS)}
        style={scrollAreaStyle}
      >
        {children}
      </div>
    </div>
  );
}
